import "../../../design/arrowToUp.css";
import { FaArrowUp } from "react-icons/fa";
import { useEffect, useState } from "react";

export default function ArrowToHeader() {
    const [show, setShow] = useState(false);

    const goToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    useEffect(() => {
        const handleScroll = () => {
            setShow(window.scrollY > 300);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            {show && (
                <button
                    className="atuSpace glass-panel"
                    onClick={goToTop}
                    aria-label="Scroll to top"
                >
                    <FaArrowUp size={18} />
                </button>
            )}
        </>
    );
}